'use client';

import { FC } from 'react';
import Skeleton from '../skeleton';
import FeedbackIconLayer from './components/feedback-icon-layer';
import useClassNames from './hooks/useClassNames';
import { ButtonProps } from './types';

const Button: FC<ButtonProps> = ({
  Icon,
  added,
  loading,
  children,
  className,
  disabled,
  asSkeleton = false,
  iconPosition = 'right',
  variant = 'primary',
  size = variant === 'underlined' ? 'fit' : 's',
  iconClassName: customIconClassName,
  ...props
}) => {
  const { buttonClassName, iconClassName } = useClassNames({
    variant,
    size,
    className,
    includesIcon: !!Icon && !!children,
    isIconOnly: !!Icon && !children,
    iconPosition,
    loading,
    asSkeleton,
  });

   return (
    <button
      {...props}
      className={`${buttonClassName} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black`}
      disabled={disabled && !loading}
    >
      {(loading || added) && <FeedbackIconLayer loading={loading} variant={variant} />}
      {children}
      {Icon && <Icon className={`${iconClassName} ${customIconClassName || ''}`} />}
      {asSkeleton && <Skeleton data-testid="skeleton" />}
    </button>
  );
};

export default Button;
